module.exports = __webpack_public_path__ + "static/media/left.56ad8aaa.svg";